var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:'tooltip-' + _vm.tooltipName,class:_vm.tooltipClass},[_c('div',{staticClass:"f-tooltip-text",style:(_vm.currentTooltipStyle)},[_c('p',{staticClass:"my-0 inline-block"},[_vm._v(_vm._s(_vm.tooltipText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }